import styled, { css } from "styled-components"

import { color } from "../../../atoms/colors"

export const DesktopWrapper = styled.div`
  @media (max-width: 1200px) {
    display: none;
  }
`

export const MobileWrapper = styled.div`
  display: none;
  max-width: 99vw;
  @media (max-width: 1200px) {
    display: block;
  }
`

export const Table = styled.table`
  border-collapse: separate;
  border-spacing: 0px;
  border: 1px solid ${color.copy[200]};
  border-radius: 8px;
  width: 100%;
  p {
    margin-bottom: 0;
  }
  th {
    vertical-align: top;
    color: ${color.oxfordBlue[900]};
  }
  @media (max-width: 1200px) {
    border-radius: 0 0 8px 8px;
    td,
    th {
      width: 50%;
    }
  }
`

export const PackageTableHeader = styled.thead`
  th:first-child {
    border-top-left-radius: 8px;
  }
  th:last-child {
    border-top-right-radius: 8px;
  }
  z-index: 1;
  ${(props) =>
    props?.isTableNavSticky &&
    css`
      position: sticky;
      top: 146px;
      &:before {
        z-index: -2;
        content: "";
        display: block;
        width: calc(100% + 2px);
        height: ${props?.headerHeight}px;
        position: absolute;
        top: 0;
        left: -1px;
        background: linear-gradient(
          180deg,
          ${color.common.white} 0%,
          ${color.copy[200]} 100%
        );
        border-radius: 0px 0px 8px 8px;
      }
      &:after {
        z-index: -1;
        content: "";
        display: block;
        width: 100%;
        height: ${props?.headerHeight}px;
        position: absolute;
        top: 0;
        left: 0;
        background-color: ${color.common.white};
        box-shadow: 0px 12px 16px rgba(1, 85, 252, 0.1);
        border-radius: 0px 0px 8px 8px;
      }
    `}
  tr {
    width: 100%;
    max-width: 1170px;
    margin: 0 auto;
    z-index: 1;
  }
`

export const SectionTitle = styled.td`
  color: ${color.oxfordBlue[900]};
  text-transform: uppercase;
  font-weight: 900;
  padding: 24px;
`

export const SectionWrapper = styled.tbody`
  th,
  td {
    border-bottom: 1px solid ${color.copy[200]};
  }
  tr:nth-child(odd) {
    background-color: ${color.gray[50]};
  }
  tr:first-child {
    background-color: ${color.daveysGray[200]};
  }
  &:last-child {
    tr:last-child {
      th,
      td {
        border-bottom: ${color.common.transparent};
      }
    }
  }
`

export const Row = styled.tr`
  th,
  td {
    padding: 24px 16px;
  }
  th {
    font-weight: 400;
    padding-left: 24px;
  }
`

export const PackageTableCell = styled.tr``

export const MobileNavWrapper = styled.div`
  ${(props) =>
    props?.isTableNavSticky &&
    css`
      z-index: 1;
      position: sticky;
      top: ${props?.isMobileNavHidden === true ? 0 : 146}px;
      border: 1px solid ${color.copy[200]};
      border-radius: 8px;
      transition: top 0.1s ease-in-out 0.2s;
      @media (max-width: 1200px) {
        button {
          padding: 12px;
          h3 {
            font-size: 18px;
          }
          & > div {
            gap: 5px;
            svg {
              width: 12px;
            }
          }
        }
      }
      @media (max-width: 768px) {
        margin-left: -30px;
        border-radius: 0;
        max-width: calc(100% + 60px);
        width: calc(100% + 60px);
        border-radius: 0;
        border-top: unset;
        border-left: unset;
        border-right: unset;
        button {
          min-width: 154px;
        }
      }
      & > div {
        border-color: ${color.common.transparent};
        border-radius: 8px;
        @media (max-width: 768px) {
          border-radius: 0;
        }
      }

      &:after {
        z-index: -1;
        content: "";
        display: block;
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        box-shadow: 0px 12px 16px -4px rgba(1, 85, 252, 0.1),
          0px 4px 6px -2px rgba(21, 91, 230, 0.05);
        border-top: 1px solid ${color.copy[200]};
      }
    `}
`

export const MobileNav = styled.div`
  display: flex;
  z-index: 1;
  overflow-x: auto;
  max-width: 100%;
  width: 100%;
  border: 1px solid ${color.copy[200]};
  border-radius: 8px 8px 0 0;
  position: relative;
  ${(props) => props?.isTableNavSticky && css``}

  background-color: ${color.common.white};
  &::-webkit-scrollbar {
    height: 16px;
  }
  &::-webkit-scrollbar-thumb {
    background: ${color.gray[200]};
    border-radius: 8px;
    border: solid 4px ${color.common.white};
  }
  &::-webkit-scrollbar-thumb:hover {
    background: ${color.gray[200]};
  }
  &::-moz-scrollbar-button,
  &::-webkit-scrollbar-button {
    width: 0px;
  }
`
export const MobileNavItem = styled.button`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  min-width: 200px;
  font-family: "Avenir";
  font-style: normal;
  font-weight: 900;
  font-size: 20px;
  line-height: 30px;
  color: ${color.oxfordBlue[900]};
  border: ${color.common.transparent};
  border-right: 1px solid ${color.copy[200]};
  background: ${color.common.white};
  padding: 24px;
  &:last-child {
    border-right: ${color.common.transparent};
  }
  &.nav-item-active {
    background: ${color.oxfordBlue[900]};
    border: 1px solid ${color.oxfordBlue[900]};
    h3 {
      color: ${color.common.white};
    }
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  p {
    margin-bottom: 0px;
  }
  @media (max-width: 1200px) {
    padding: 16px;
    min-width: 154px;
  }
  @media (max-width: 768px) {
    min-width: 200px;
  }
`
